const locations = [
  { value: 'Charlotte, NC', label: 'Charlotte, NC' },
  { value: 'Chicago, IL', label: 'Chicago, IL' },
  { value: 'Dallas, TX', label: 'Dallas, TX' },
  { value: 'Dayton, OH', label: 'Dayton, OH' },
  { value: 'Detroit, MI', label: 'Detroit, MI' },
  { value: 'Fremont, CA', label: 'Fremont, CA' },
  { value: 'Irvine, CA', label: 'Irvine, CA' },
  { value: 'Lehi, UT', label: 'Lehi, UT' },
  { value: 'Milwaukee, WI', label: 'Milwaukee, WI' },
  { value: 'Nashville, TN', label: 'Nashville, TN' },
  { value: 'Oceanside, CA', label: 'Oceanside, CA' },
  { value: 'Philadelphia, PA', label: 'Philadelphia, PA' },
  { value: 'Phoenix, AZ', label: 'Phoenix, AZ' },
  { value: 'North Kingstown, RI', label: 'North Kingstown, RI' },
  { value: 'Seattle, WA', label: 'Seattle, WA' },
]

export default locations
